import * as ApiManager from './_manager'
import store from '../store';

export const plan = {
    getPlans: (payload) => {
        return ApiManager.callApi (`/member/company/${store.getters['company/getSelected']}/subscription/plan/getPlans`, payload);
    },

    createPlan: (payload) => {
        return ApiManager.callApi (`/member/company/${store.getters['company/getSelected']}/subscription/plan/createPlan`, payload);
    },

    updatePlan: (payload) => {
        return ApiManager.callApi (`/member/company/${store.getters['company/getSelected']}/subscription/plan/updatePlan`, payload);
    }
}
